/**
 * Left Arrow Button Component
 * Custom styled arrow button for horizontal scrolling
 */

import React from 'react';

export interface LeftArrowButtonProps {
  onClick?: () => void;
  ariaLabel?: string;
}

export const LeftArrowButton: React.FC<LeftArrowButtonProps> = ({
  onClick,
  ariaLabel = 'Scroll left',
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        display: 'flex',
        padding: '8px',
        alignItems: 'center',
        gap: '8px',
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        borderRadius: 'var(--Dimensions-Border-border-Full, 9999px)',
        border: '1px solid var(--Colors-Stroke-Base, #D6D3D1)',
        background: 'rgba(28, 25, 23, 0.50)',
        width: '36px',
        height: '36px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s',
        justifyContent: 'center',
        zIndex: 10,
      }}
      onMouseEnter={e => {
        if (onClick) {
          e.currentTarget.style.opacity = '0.8';
        }
      }}
      onMouseLeave={e => {
        if (onClick) {
          e.currentTarget.style.opacity = '1';
        }
      }}
    >
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 5L7 10L12 15M7 10H17'
          stroke='#FFFFFF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </button>
  );
};
